// @ts-nocheck
/* eslint-disable consistent-return */
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../../configs';
import { toastTypes } from '../../enums';
import getRoot from '../root';

const PATH = `${API_URL}/api/integrations/Shopify`;

const TIER_LIST = [
  { name: 'Startup', price: '149.99', header: 'Gotta Get That!', planDescription: ['750 Form Tracks', 'Dashboard Access', 'Email Sending Access', 'Capture on 1 Domain'], icon: 'truck', color: 'green' },
  { name: 'Growth', price: '289.99', header: 'Keep it Going!', planDescription: ['1500 Form Tracks', 'Dashboard Access', 'Email Sending Access', 'Capture on 1 Domain'], icon: 'train', color: 'yellow' },
  { name: 'Scale', price: '549.99', header: 'Mover and Shaker.', planDescription: ['3000 Form Tracks', 'Dashboard Access', 'Email Sending Access', 'Capture on 1 Domain'], icon: 'plane', color: 'orange' },
  { name: 'EnterpriseLite', price: '999.99', header: 'Now We\'re Talking.', planDescription: ['6000 Form Tracks', 'Dashboard Access', 'Email Sending Access', 'Capture on Multiple Domains'], icon: 'rocket', color: 'red' },
];

const useShopifyStore = create((set, get) => ({
  configs: { enabled: false },
  loading: false,
  tierList: TIER_LIST,

  reset: () => set({ configs: {}, loading: false }),

  setConfigField: (name, value) => set((s) => ({ configs: { ...s.configs, [name]: value } })),

  getConfigs: async () => {
    try {
      set({ loading: true });
      const { data } = await axios.get(`${PATH}/config`);
      if (data.success) set((s) => ({ configs: { ...s.configs, ...data.config } }));
    } catch (e) { /* ignore */ } finally {
      set({ loading: false });
    }
  },

  updateConfigs: async () => {
    const root = getRoot();
    try {
      set({ loading: true });
      const { data } = await axios.post(`${PATH}/config`, { ...get().configs });
      if (data.success) {
        root.success('Successfully updated the configurations.', toastTypes.shopifyUpdateConfigs);
        root.clearToast(toastTypes.shopifyUpdateConfigs);
      } else throw new Error();
    } catch (e) {
      root.failure('Something went wrong...', toastTypes.shopifyUpdateConfigs);
    } finally {
      get().getConfigs();
      set({ loading: false });
    }
  },

  setup: async (code, instanceId) => {
    const root = getRoot();
    try {
      set({ loading: true });
      const { data } = await axios.post(`${PATH}/setup`, { code, instanceId });
      if (data.success) {
        root.success('Shopify integration successful.', toastTypes.shopifySetUp);
        root.clearToast(toastTypes.shopifySetUp);
      } else throw new Error();
    } catch (e) {
      root.failure('Shopify integration unsuccessful.', toastTypes.shopifySetUp);
    } finally {
      set({ loading: false });
      get().getConfigs();
    }
  },

  getTokens: async ({ code, hmac, shop, state }) => {
    const root = getRoot();
    try {
      set({ loading: true });
      const url = `${PATH}/token?code=${code}&hmac=${hmac}&state=${state}&shop=${shop}`;
      const { data } = await axios.get(url);
      if (data.success) {
        get().getConfigs();
        root.success('Shopify integration successful.', toastTypes.shopifyGetTokens);
        root.clearToast(toastTypes.shopifyGetTokens);
      } else throw new Error();
    } catch (e) {
      root.failure('Shopify integration unsuccessful.', toastTypes.shopifyGetTokens);
    } finally {
      set({ loading: false });
    }
  },

  paymentUrl: async (name) => {
    const root = getRoot();
    root.success('Redirecting to Authorize Payment', toastTypes.paymentUrl);
    root.clearToast(toastTypes.paymentUrl);
    try {
      set({ loading: true });
      const { data } = await axios.get(`${PATH}/payment/plan/${name}`);
      return data;
    } catch (e) {
      root.failure('Something went wrong...', toastTypes.paymentUrl);
    } finally {
      set({ loading: false });
    }
  },

  activateCharge: async (chargeId) => {
    const root = getRoot();
    try {
      set({ loading: true });
      const { data } = await axios.post(`${PATH}/payment/activate`, { chargeId });
      root.success('Plan successfuly updated.', toastTypes.activateCharge);
      root.clearToast(toastTypes.activateCharge);
      return data;
    } catch (e) {
      root.failure('Something went wrong...', toastTypes.activateCharge);
    } finally {
      set({ loading: false });
    }
  },
}));

export default useShopifyStore;
